import { handleGetSaInvitedApplicants, handleSaInvitedApplicantSearch, handleSaInvitedApplicantsFilter } from 'Actions/SuperAdmin/JobsAction';
import InfoAddCard from 'components/Cards/InfoAddCard';
import InfoEditCard from 'components/Cards/InfoEditCard';
import React, { useEffect } from 'react'
import InputGroup from 'components/Input/InputGroup';
import toast from 'react-hot-toast';
import { FaGraduationCap, FaUserTie } from 'react-icons/fa';
import { FaArrowLeftLong } from 'react-icons/fa6';
import { FiInfo } from 'react-icons/fi';
import { GrMenu } from 'react-icons/gr'
import { HiLightBulb } from 'react-icons/hi2';
import { IoIosSearch } from 'react-icons/io';
import { MdClear } from 'react-icons/md';
import { PiBagFill } from 'react-icons/pi';
import { useSelector } from 'react-redux';
import { useCustomNavigate, useDispatch } from 'ReusableFunctions/CustomHooks'
import { decryptData } from 'Security/Crypto/Crypto';
import images from 'utils/images';
import CandidateProfile from 'views/employer/CandidateProfile';
import { updateApplicantSearch, updateShowEmployerDetails } from 'Slices/SuperAdmin/Jobs';

const SaInvitedApplicants = () => {
    const { commonState, saJobsState } = useSelector((state) => state);
    const dispatch = useDispatch();
    const pageRender = useCustomNavigate();
    const queryParams = new URLSearchParams(window.location.search);
    const job_id = queryParams.get("id");
    const decrypted_job_id = decryptData(job_id);
    const invitedApplicantsStatusArray = ["All", "Invited from Best fit", "Invited from pool page"]

    useEffect(() => {
        if (job_id) {
            if (typeof decrypted_job_id === "number") {
                dispatch(handleGetSaInvitedApplicants({ job_id: decrypted_job_id }))
            } else {
                pageRender("/super_admin/jobs")
                toast.error("Invalid id")
            }
        }
    }, []);


    return (
        <div className="col-12 col-xxl-10 superAdmin-rightSide-total-height overflow-hidden">
            <div className="col-12 superAdmin-rightSide-Component-name-height">
                <div className="container-fluid px-lg-4 h-100 shadow">
                    <div className="row align-items-center h-100 ">
                        <div className="col-6">
                            <h5>Jobs</h5>
                        </div>

                        <div className="col-6 text-end d-xxl-none">
                            <button className="navbar-toggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#superAdminSidebar" aria-controls="superAdminSidebar">
                                <GrMenu className='fs-4' />
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-12 superAdmin-rightSide-Component-content-height placeholder-glow">
                <div className="homePage-backgroundColor h-100 overflow-scroll">
                    <div className="container-fluid">
                        <div className="d-flex flex-wrap pt-3 align-items-center">
                            <div className="col-12 col-lg-7 py-2 py-md-0">
                                <button
                                    className="btn btn-transparent d-flex align-items-center gap-2"
                                    onClick={() => {
                                        pageRender(`/super_admin/jobs/job_id?id=${job_id}&responsive=false`);
                                    }}
                                >
                                    <FaArrowLeftLong className="fs-5" /> Invited Applicants
                                </button>
                            </div>

                            <div className="col-12 col-lg-5 mb-lg-2">
                                {
                                    saJobsState?.candidate_job_role ?
                                        <p className='w-100 mb-0'>
                                            <strong>Job Title : </strong>
                                            {saJobsState?.candidate_job_role}
                                        </p>
                                        :
                                        null
                                }
                            </div>

                            <div className="col-12 col-lg-7">
                                <p className='px-3 pt-3 mb-0 text-secondary fs-14'>
                                    <strong>Showing : </strong>
                                    {saJobsState?.invited_applicats?.length} results
                                </p>
                            </div>

                            <div className={!saJobsState?.initialGlow ? "col-12 col-lg-5 d-flex flex-wrap" : "d-none"} id="searchInputField">
                                <div className="col-4 pe-2">
                                    <div className="dropdown employer-custom-dropdown">
                                        <button
                                            id="applicantsStatusButton"
                                            className="btn dropdown-toggle w-100 filter-section d-flex flex-wrap align-items-center choose-dropdown"
                                            type="button"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                            disabled={saJobsState?.initialGlow}
                                        >
                                            <span className="fw-bold">Filter</span>
                                            <span
                                                className="text-secondary ps-2 text-truncate"
                                                style={{
                                                    maxWidth: '70%',
                                                    whiteSpace: 'nowrap',
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                }}>
                                                {saJobsState?.applicants_filter_status}
                                            </span>
                                        </button>

                                        <ul className={`dropdown-menu w-100 border-0 shadow ${saJobsState?.initialGlow ? 'pe-none dropdown-box-disable' : ''}`}>
                                            {
                                                invitedApplicantsStatusArray.map((v, i) => {
                                                    return <li key={i}>
                                                        <a className={`dropdown-item dropdown-jobSort ${saJobsState?.initialGlow ? 'pe-none dropdown-List-disable' : ''}`}
                                                            onClick={() => dispatch(handleSaInvitedApplicantsFilter({ status: v, data: saJobsState }))}
                                                        >
                                                            {invitedApplicantsStatusArray[i]}
                                                        </a>
                                                    </li>
                                                })
                                            }
                                        </ul>
                                    </div>
                                </div>

                                <div className="d-flex position-relative col-8" >
                                    <InputGroup
                                        className="home-search-icon fs-5"
                                        reIcons={<IoIosSearch />}
                                    />

                                    <input
                                        type="text"
                                        className="form-control form-control-lg searchInput candidate-searchInput border-0 px-2 py-0 searchInput-border"
                                        placeholder="Search by user id, skill, experience, education"
                                        aria-label="default input example"
                                        value={saJobsState?.applicant_search_value}
                                        onChange={(e) => dispatch(updateApplicantSearch(e.target.value))}
                                        onKeyDown={(e) => {
                                            if (e.key === "Enter") {
                                                dispatch(handleSaInvitedApplicantSearch({ job_id: decrypted_job_id?.toString(), search_req_from: "", search_text: saJobsState?.applicant_search_value }))
                                            }
                                        }}
                                    />

                                    {
                                        saJobsState?.applicant_search_value ?
                                            <div
                                                className="searchButtonClick-superAdmin "
                                                title="Search"
                                                onClick={() => dispatch(handleSaInvitedApplicantSearch({ job_id: decrypted_job_id, search_req_from: "", search_text: saJobsState?.applicant_search_value }))}
                                            >
                                                <IoIosSearch />
                                            </div>
                                            :
                                            null
                                    }

                                    <div
                                        className="clearButtonClick-superAdmin"
                                        title="Clear"
                                        onClick={saJobsState?.isSearched ? () => dispatch(handleGetSaInvitedApplicants({ job_id: decrypted_job_id })) : null}
                                    >
                                        <MdClear />
                                    </div>
                                </div>
                            </div>
                        </div>


                        {saJobsState?.initialGlow ?
                            <>
                                <div className="card border-0 shadow-sm px-5 py-3 my-4 placeholder-glow ">
                                    <div className="row">
                                        <div className="col-lg-6 col-md-12">
                                            <InfoEditCard
                                                pageContentLoaded={!saJobsState?.initialGlow}
                                                cardHeadingIcon={
                                                    <FaUserTie
                                                        className={
                                                            !saJobsState?.initialGlow
                                                                ? "me-4 brand-color fs-4"
                                                                : "me-4  fs-4 placeholder rounded-2"
                                                        }
                                                    />
                                                }
                                                cardHeading="About"
                                                id="pageTop"
                                                placeholder="Provide a brief description about yourself"
                                                cardContent="about content"
                                            />
                                        </div>
                                        <div className="col-lg-6 col-md-12">
                                            <InfoEditCard
                                                pageContentLoaded={!saJobsState?.initialGlow}
                                                cardHeadingIcon={
                                                    <FaUserTie
                                                        className={
                                                            !saJobsState?.initialGlow
                                                                ? "me-4 brand-color fs-4"
                                                                : "me-4  fs-4 placeholder rounded-2"
                                                        }
                                                    />
                                                }
                                                cardHeading="About"
                                                id="pageTop"
                                                placeholder="Provide a brief description about yourself"
                                                cardContent="about content"
                                            />
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-lg-6 col-md-12">
                                            <div className="card mt-3 border-0 shadow-sm rounded-4">
                                                <div className="card-body">
                                                    <div className="d-flex justify-content-between ms-1">
                                                        <label className="profile-side-headers d-flex align-items-center placeholder-glow">
                                                            <HiLightBulb
                                                                className={
                                                                    !saJobsState?.initialGlow
                                                                        ? "me-4 brand-color fs-4"
                                                                        : "me-4  fs-3 placeholder rounded-2"
                                                                }
                                                            />
                                                            <span
                                                                className={
                                                                    !saJobsState?.initialGlow
                                                                        ? ""
                                                                        : "placeholder px-3 w-100 py-1  rounded-1"
                                                                }
                                                            >
                                                                Skills
                                                            </span>
                                                        </label>
                                                    </div>

                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <div className="row row-cols-auto ms-5 g-3 profile-descriptions mt-3">
                                                            <p
                                                                className={
                                                                    !saJobsState?.initialGlow
                                                                        ? "mt-0 word-space-content px-0 ms-1"
                                                                        : "placeholder px-3 py-2 mt-0 rounded-1"
                                                                }
                                                            >
                                                                Your skills will be displayed here
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-12">
                                            <InfoEditCard
                                                pageContentLoaded={!saJobsState?.initialGlow}
                                                cardHeadingIcon={
                                                    <FaUserTie
                                                        className={
                                                            !saJobsState?.initialGlow
                                                                ? "me-4 brand-color fs-4"
                                                                : "me-4  fs-4 placeholder rounded-2"
                                                        }
                                                    />
                                                }
                                                cardHeading="About"
                                                id="pageTop"
                                                placeholder="Provide a brief description about yourself"
                                                cardContent="about content"
                                            />
                                        </div>
                                    </div>

                                    <div className="mt-4 text-end">
                                        <button
                                            className={
                                                !saJobsState?.initialGlow
                                                    ? "btn btn-brand-color"
                                                    : "btn  placeholder rounded-2"
                                            }
                                            data-bs-toggle="modal"
                                            data-bs-target="#fullProfileModal"
                                        >
                                            Click here to see full profile
                                        </button>
                                    </div>
                                </div>
                                <div className="card border-0 shadow-sm px-5 py-3 my-4 placeholder-glow ">
                                    <div className="row">
                                        <div className="col-lg-6 col-md-12">
                                            <InfoEditCard
                                                pageContentLoaded={!saJobsState?.initialGlow}
                                                cardHeadingIcon={
                                                    <FaUserTie
                                                        className={
                                                            !saJobsState?.initialGlow
                                                                ? "me-4 brand-color fs-4"
                                                                : "me-4  fs-4 placeholder rounded-2"
                                                        }
                                                    />
                                                }
                                                cardHeading="About"
                                                id="pageTop"
                                                placeholder="Provide a brief description about yourself"
                                                cardContent="about content"
                                            />
                                        </div>
                                        <div className="col-lg-6 col-md-12">
                                            <InfoEditCard
                                                pageContentLoaded={!saJobsState?.initialGlow}
                                                cardHeadingIcon={
                                                    <FaUserTie
                                                        className={
                                                            !saJobsState?.initialGlow
                                                                ? "me-4 brand-color fs-4"
                                                                : "me-4  fs-4 placeholder rounded-2"
                                                        }
                                                    />
                                                }
                                                cardHeading="About"
                                                id="pageTop"
                                                placeholder="Provide a brief description about yourself"
                                                cardContent="about content"
                                            />
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-lg-6 col-md-12">
                                            <div className="card mt-3 border-0 shadow-sm  rounded-4">
                                                <div className="card-body">
                                                    <div className="d-flex justify-content-between ms-1">
                                                        <label className="profile-side-headers d-flex align-items-center placeholder-glow">
                                                            <HiLightBulb
                                                                className={
                                                                    !saJobsState?.initialGlow
                                                                        ? "me-4 brand-color fs-4"
                                                                        : "me-4  fs-3 placeholder rounded-2"
                                                                }
                                                            />
                                                            <span
                                                                className={
                                                                    !saJobsState?.initialGlow
                                                                        ? ""
                                                                        : "placeholder px-3 w-100 py-1  rounded-1"
                                                                }
                                                            >
                                                                Skills
                                                            </span>
                                                        </label>
                                                    </div>

                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <div className="row row-cols-auto ms-5 g-3 profile-descriptions mt-3">
                                                            <p
                                                                className={
                                                                    !saJobsState?.initialGlow
                                                                        ? "mt-0 word-space-content px-0 ms-1"
                                                                        : "placeholder px-3 py-2 mt-0 rounded-1"
                                                                }
                                                            >
                                                                Your skills will be displayed here
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-12">
                                            <InfoEditCard
                                                pageContentLoaded={!saJobsState?.initialGlow}
                                                cardHeadingIcon={
                                                    <FaUserTie
                                                        className={
                                                            !saJobsState?.initialGlow
                                                                ? "me-4 brand-color fs-4"
                                                                : "me-4  fs-4 placeholder rounded-2"
                                                        }
                                                    />
                                                }
                                                cardHeading="About"
                                                id="pageTop"
                                                placeholder="Provide a brief description about yourself"
                                                cardContent="about content"
                                            />
                                        </div>
                                    </div>

                                    <div className="mt-4 text-end">
                                        <button
                                            className={
                                                !saJobsState?.initialGlow
                                                    ? "btn btn-brand-color"
                                                    : "btn  placeholder rounded-2"
                                            }
                                            data-bs-toggle="modal"
                                            data-bs-target="#fullProfileModal"
                                        >
                                            Click here to see full profile
                                        </button>
                                    </div>
                                </div>
                            </>
                            :
                            saJobsState?.invited_applicats?.length ?
                                saJobsState?.invited_applicats?.map((value, i) => {
                                    return (
                                        <React.Fragment key={value?.id}>
                                            {value?.about?.length === 0 &&
                                                value?.experience?.length === 0 &&
                                                value?.skills?.length === 0 &&
                                                value?.education?.length === 0 ? null : (
                                                <div
                                                    className={`card border-0 shadow-sm ${commonState?.isSmallDevice ? "px-3" : "px-5"
                                                        } py-3 my-4 placeholder-glow h-100`}
                                                >
                                                    <div className="row" id={i === 0 ? "firstCard" : ""}>
                                                        <div className="card-header bg-transparent d-flex justify-content-between align-items-center">
                                                            <p className={!saJobsState?.initialGlow ?
                                                                "mb-1"
                                                                :
                                                                "placeholder py-2 rounded-2"
                                                            }>
                                                                USER ID :{" "}
                                                                <strong>{value?.professional_id}</strong>

                                                                <span className={`ms-3 ${value?.invited_mode === 'from pool page' || value?.invited_mode === null ? 'invite_from_pool_page' : 'invite_from_best_fit'}`}>
                                                                    Invited {value?.invited_mode === 'from pool page' || value?.invited_mode === null ? 'from pool page' : 'from best fit applicants'}
                                                                </span>
                                                            </p>

                                                            <div className={` ${commonState?.isSmallDevice ? "text-center" : "text-end"}`} id={`viewFullProfile${value?.id}Button`} >
                                                                <button id={`${i === 0 ? "clickToSeeProfile2" : ""}`}
                                                                    className={!saJobsState?.initialGlow ? `btn border-brand-color py-1` : "btn btn-sm placeholder rounded-2"}
                                                                    data-bs-toggle="modal"
                                                                    data-bs-target="#fullProfileModal"
                                                                    onClick={() => dispatch(updateShowEmployerDetails(value?.professional_id))}
                                                                >
                                                                    View full profile
                                                                </button>
                                                            </div>
                                                        </div>

                                                        {value.about.length === 0 ? null : (
                                                            <div className="col-lg-6 col-md-12 ">
                                                                <InfoEditCard
                                                                    pageContentLoaded={!saJobsState?.initialGlow}
                                                                    cardHeadingIcon={
                                                                        <FaUserTie
                                                                            className={!saJobsState?.initialGlow ? "me-4 brand-color fs-4"
                                                                                : "me-4  fs-4 placeholder rounded-2"
                                                                            } />
                                                                    }
                                                                    cardHeading="About"
                                                                    id="pageTop"
                                                                    placeholder="Provide a brief description about yourself"
                                                                    cardContent={value?.about?.length > 200 ?
                                                                        `${value?.about?.slice(0, 250)}..`
                                                                        : `${value?.about}`
                                                                    }
                                                                    mobileScreen={commonState?.isSmallDevice}
                                                                />
                                                            </div>
                                                        )}

                                                        {value?.experience?.length === 0 ? null : (
                                                            <div className="col-lg-6 col-md-12">
                                                                <InfoAddCard
                                                                    pageContentLoaded={!saJobsState?.initialGlow}
                                                                    cardHeadingIcon={
                                                                        <PiBagFill
                                                                            className={
                                                                                !saJobsState?.initialGlow
                                                                                    ? "me-4 brand-color fs-4"
                                                                                    : "me-4  fs-4 placeholder rounded-2"
                                                                            }
                                                                        />
                                                                    }
                                                                    cardHeading="Experience"
                                                                    placeholder="Your experience details will be displayed here"
                                                                    arrayContent={value?.experience[0]}
                                                                    currentPage="employerPool"
                                                                    mobileScreen={commonState?.isSmallDevice}
                                                                />
                                                            </div>
                                                        )}

                                                        {value?.skills?.length === 0 ? null : (
                                                            <div className="col-lg-6 col-md-12">
                                                                <div className="card mt-3 border-0 rounded-4">
                                                                    <div
                                                                        className={`card-body ${commonState?.isSmallDevice ? "px-0 py-0" : ""
                                                                            }`}
                                                                    >
                                                                        <div className="d-flex justify-content-between ms-1">
                                                                            <label className="profile-side-headers d-flex align-items-center placeholder-glow">
                                                                                <HiLightBulb
                                                                                    className={
                                                                                        !saJobsState?.initialGlow
                                                                                            ? "me-4 brand-color fs-4"
                                                                                            : "me-4  fs-3 placeholder rounded-2"
                                                                                    }
                                                                                />
                                                                                <span
                                                                                    className={
                                                                                        !saJobsState?.initialGlow
                                                                                            ? ""
                                                                                            : "placeholder px-3 w-100 py-1  rounded-1"
                                                                                    }
                                                                                >
                                                                                    Skills
                                                                                </span>
                                                                            </label>
                                                                        </div>

                                                                        <div className="d-flex justify-content-between align-items-center">
                                                                            <div className="row row-cols-auto ms-5 g-3 profile-descriptions mt-3">
                                                                                {value?.skills?.length === 0 ? (
                                                                                    <p
                                                                                        className={
                                                                                            !saJobsState?.initialGlow
                                                                                                ? "mt-0 word-space-content px-0 ms-1"
                                                                                                : "placeholder px-3 py-2 mt-0 rounded-1"
                                                                                        }
                                                                                    >
                                                                                        Your skills will be displayed here
                                                                                    </p>
                                                                                ) : (
                                                                                    value?.skills
                                                                                        .slice(0, 5)
                                                                                        .map((skill, id) => {
                                                                                            return (
                                                                                                <React.Fragment key={skill?.id}>
                                                                                                    <div className="col mt-0  px-0 me-2">
                                                                                                        <div
                                                                                                            className={
                                                                                                                !saJobsState?.initialGlow
                                                                                                                    ? "border rounded-2 p-2 fw-bold mb-3 "
                                                                                                                    : "border rounded-2 p-2 fw-bold mb-4 placeholder"
                                                                                                            }
                                                                                                        >
                                                                                                            <span className="textTransform">
                                                                                                                {skill?.skill_name}
                                                                                                            </span>{" "}
                                                                                                            {skill?.skill_level
                                                                                                                ? "-"
                                                                                                                : null}{" "}
                                                                                                            <span className="fw-normal">
                                                                                                                {skill?.skill_level}
                                                                                                            </span>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </React.Fragment>
                                                                                            );
                                                                                        })
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}

                                                        {value.education.length === 0 ? null : (
                                                            <div className="col-lg-6 col-md-12">
                                                                <InfoAddCard
                                                                    pageContentLoaded={!saJobsState?.initialGlow}
                                                                    cardHeadingIcon={
                                                                        <FaGraduationCap
                                                                            className={
                                                                                !saJobsState?.initialGlow
                                                                                    ? "me-4 brand-color fs-4"
                                                                                    : "me-4  fs-4 placeholder rounded-2"
                                                                            }
                                                                        />
                                                                    }
                                                                    cardHeading="Education"
                                                                    placeholder="Your education details will be displayed here"
                                                                    arrayContent={value.education[0]}
                                                                    currentPage="employerPool"
                                                                    mobileScreen={commonState?.isSmallDevice}
                                                                />
                                                            </div>
                                                        )}

                                                        {
                                                            value?.applied_status === "applied" ?
                                                                <hr
                                                                    className={`mt-2`}
                                                                />
                                                                :
                                                                null
                                                        }
                                                    </div>

                                                    {
                                                        value?.applied_status === "applied" ?
                                                            <div className='w-100 d-flex flex-wrap mt-2 align-items-center'>
                                                                <div className="col-8 profile-descriptions">
                                                                    <p className='text-secondary mb-0'>
                                                                        <FiInfo size={19} />
                                                                        <span className='ps-1'>The invited candidate has applied for the job.</span>
                                                                    </p>

                                                                </div>
                                                                {/* <div className="col text-end">
                                                                    <div id={`inviteToInterview${value.id}Button`}>
                                                                        <button id={`${i === 0 ? "clickToSeeProfile2" : ""}`} className={!saJobsState?.initialGlow ? "btn btn-brand-color pe-none opacity-75" : "btn  placeholder rounded-2"} >
                                                                            Invited
                                                                        </button>
                                                                    </div>
                                                                </div> */}
                                                            </div>
                                                            :
                                                            null
                                                    }
                                                </div>
                                            )}
                                        </React.Fragment>
                                    );
                                })
                                :
                                <div className="h-100">
                                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                        <div className="d-flex  justify-content-center vh-80 align-items-center">
                                            <img
                                                src={images.noRecordsFound}
                                                width={250}
                                                height={250}
                                            />
                                        </div>
                                    </div>
                                </div>
                        }
                    </div>
                </div>

                {/* <div className="scroll-to-top-icon"
                    id="scroll-to-top-icon"
                    onClick={scrollToTop}
                    title="Scroll to top"
                    style={{ display: isVisible ? "block" : "none" }}
                >
                    <BsFillArrowUpCircleFill className="fs-1 brand-color" />
                </div> */}

                <div
                    className="modal fade"
                    id="fullProfileModal"
                    data-bs-keyboard="false"
                    tabIndex="-1"
                    aria-labelledby="staticBackdropLabel"
                    aria-hidden="true"
                >
                    <div className="modal-dialog modal-dialog-centered modal-xl">
                        <div
                            className={`modal-content ${commonState?.isSmallDevice ? "px-0 " : "px-3"} mx-2 `}
                        >
                            <div className="modal-header border-bottom-0 ">
                                <h1 className="modal-title fs-5 mt-2" id="staticBackdropLabel">
                                    Applicant full profile
                                </h1>
                                <button
                                    id="closeViewProfileButton"
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                ></button>
                            </div>
                            <div className="modal-body border-bottom-0 ">
                                <div className="container px-0">
                                    {
                                        saJobsState?.professional_id ?
                                            <CandidateProfile
                                                professionalId={saJobsState?.professional_id}
                                                mobileScreen={commonState?.isSmallDevice}
                                            />
                                            :
                                            null
                                    }
                                </div>
                            </div>
                            <div className="modal-footer border-top-0">
                                <div className="container">
                                    <div className="row float-end">
                                        <div className="col-lg-12 ">
                                            <button
                                                type="button"
                                                className="btn btn-outline-secondary"
                                                data-bs-dismiss="modal"
                                            >
                                                <span>Cancel</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >

    )
}

export default SaInvitedApplicants